import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';

import Preloader from '@omilia/preloader';

import { mapStateToProps, mapDispatchToProps } from './utils';

const PartialImportModal = React.lazy(() =>
  import('./components/PartialImportModal'),
);

/* eslint-disable react/prop-types */
const withPartialImportModal = resource => Component => {
  const NewComponent = props => (
    <React.Fragment>
      <Component {...props} />

      <Route
        path={`${props.match.url}/import/:type`}
        render={({ match, history }) => {
          const navigateToResourceUrl = () => history.push(props.match.url);

          return (
            <React.Suspense fallback={<Preloader fullPage showBackdrop />}>
              <PartialImportModal
                downloadImportedResources={props.downloadImportedResources}
                error={props.partialImportError}
                resource={resource}
                type={match.params.type}
                onClose={navigateToResourceUrl}
                onImport={
                  match.params.type === 'merge'
                    ? props.mergeImport
                    : props.mergeReplace
                }
              />
            </React.Suspense>
          );
        }}
      />
    </React.Fragment>
  );

  return connect(
    mapStateToProps(resource),
    mapDispatchToProps(resource),
  )(NewComponent);
};

export default withPartialImportModal;
